import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "@tanstack/react-router";
import { useForm } from "react-hook-form";

import { useRequestOtp, type requestOtpResponse200 } from "@/api";
import { OtpPhoneTemplate } from "@/components/Templates";
import { otpPhoneSchema, type OtpPhoneFormValues } from "@/lib/validation/auth.schemas";

export function OtpPhonePage() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<OtpPhoneFormValues>({
    resolver: zodResolver(otpPhoneSchema),
    defaultValues: {
      phone: "",
    },
  });

  const { mutate: requestOtp, isPending } = useRequestOtp<requestOtpResponse200>({
    mutation: {
      onSuccess: (res, variables) => {
        if (res.status !== 200) return;
        navigate({
          to: "/otp/verify",
          search: {
            phone: variables.data.phone,
            resendAfter: res.data.data.resend_after,
          },
        });
      },
    },
  });

  const onSubmit = (data: OtpPhoneFormValues) => {
    requestOtp({ data });
  };

  return (
    <OtpPhoneTemplate
      register={register}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      errors={errors}
      isPending={isPending}
    />
  );
}
